/**
 * Distance from the bottom within which auto-follow re-engages. Deliberately
 * far tighter than the disengage threshold: anywhere short of flush-with-bottom
 * is someone reading, and yanking them down on the next transcript tick loses
 * their place. Naming mirrors the chat scroller's engage/disengage pair
 * (`chat/components/chat/scroll-intent.ts`).
 */
export const AUTO_SCROLL_ENGAGE_DISTANCE_PX = 8

/**
 * Hysteresis for following a live bottom edge: re-engage only at the bottom
 * (≤ `engage`), disengage only once clearly away (> `disengage`), and hold the
 * current state in the band between, so drifting near the bottom neither
 * grabs the reader nor drops a follower.
 */
export function resolveAutoFollow(
  distance: number,
  current: boolean,
  { engage, disengage }: { engage: number; disengage: number },
): boolean {
  if (distance <= engage) return true
  if (distance > disengage) return false
  return current
}
